import { CalendarClock } from 'lucide-react';
import { Badge, Card, EtatVide, PageHeader } from '@/shared/ui';
import type { EntreeNavigation } from '@/app/navigation';

/**
 * L'écran d'une rubrique pas encore livrée : il dit ce qu'elle fera et quand,
 * plutôt qu'une page blanche qui ressemble à une panne.
 */
export function EcranPrevu({ entree }: { entree: EntreeNavigation }) {
  return (
    <>
      <PageHeader icone={entree.icone} titre={entree.libelle} description={entree.description} />
      <Card>
        <EtatVide icone={CalendarClock} titre="Cet écran arrive bientôt">
          <p>{entree.description}</p>
          {entree.prevuAu ? (
            <p className="mt-3">
              <Badge ton="marque">Prévu au sprint {entree.prevuAu}</Badge>
            </p>
          ) : null}
        </EtatVide>
      </Card>
    </>
  );
}
